'use strict';

var illustration = require('../../../../../../../../../../_virtual/illustration.cjs');

const ILLUSTRATION_DIMENSIONS = {
    small: 64,
    medium: 88,
    large: 104
};

illustration.__exports.ILLUSTRATION_DIMENSIONS = ILLUSTRATION_DIMENSIONS;

module.exports = illustration.__exports;
//# sourceMappingURL=illustration.cjs.map
